import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Col, Flex, Row } from 'antd';
import AIProgressBar from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AIProgressBar/AIProgressBar';
import AiSuggestPrompts from 'components/Message/CreateMessageComponent/StepMessage/AiCreation/AiSuggestPrompts/AiSuggestPrompts';
import { useMessageService } from 'components/Message/useMessageService';
import SpeechAntdTextArea, { SpeechAntdTextAreaHandle } from 'components/UiKit/SpeechAntdTextArea/SpeechAntdTextArea';
import { useEffect, useRef, useState } from 'react';

type AllProps = {
  tones: string[];
  onBack: () => void;
  onSave: (memory?: string, shouldExit?: boolean) => void;
};

function AiCreationMemory({ tones, onBack, onSave }: AllProps) {
  const memoryRef = useRef<SpeechAntdTextAreaHandle>(null);
  const { message, updateMessageAiFields } = useMessageService();
  const [memory, setMemory] = useState<string>('');

  const handleSubmit = async (shouldExit = false) => {
    const finalMemory = (await memoryRef.current?.flush()) ?? memory;
    setMemory(finalMemory);

    await updateMessageAiFields({ aiMemory: finalMemory });
    onSave(finalMemory, shouldExit);
  };

  useEffect(() => {
    setMemory(message?.aiMemory || '');
  }, [message?.aiMemory]);

  if (!message) return null;

  return (
    <div className="ai-creation-memory create-message-component-full-height">
      <div>
        <AIProgressBar currentStep={3} />
        <div className="create-message-component-title">Any memories or phrases to include?</div>
        <div className="create-message-component-subtitle">
          Add specific moments, inside jokes, or sayings that matter to you and your loved ones.
        </div>

        <AiSuggestPrompts
          type={message.type}
          tones={tones}
          recipientName={message.contacts?.[0]?.name}
          recipientRelationship={message?.contacts?.[0]?.relationship}
          eventType={message.eventType}
          slot="Any memories or phrases to include?"
        />

        <SpeechAntdTextArea
          ref={memoryRef}
          autoFocus
          value={memory}
          onChange={(value) => {
            setMemory(value);
          }}
          placeholder="For example: 'Our trip to Yellowstone, singing in the kitchen, our family motto: Always be kind'..."
        />
      </div>

      <Row className="create-message-component-footer">
        <Col span={12}>
          <Button onClick={onBack} type="link">
            <ArrowLeftOutlined /> Back
          </Button>
        </Col>
        <Col span={12} className="text-right">
          <Flex gap={20} justify="flex-end">
            <Button onClick={() => handleSubmit(true)}>Save & Exit</Button>
            <Button type="primary" onClick={() => handleSubmit()}>
              Next
            </Button>
          </Flex>
        </Col>
      </Row>
    </div>
  );
}

export default AiCreationMemory;
